import React from "react";
import { Container } from "react-bootstrap";
import b2c from "../../../../Asset/hero-b2c.svg";

const Fourth = () => {
  return (
    <>
      <section
        className="side-image-box-section pt-5"
        style={{ background: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2">
              <div className="info-content">
                <div className="title-paragraph">
                  B2C customers search for the lowest price possible.
                </div>
                <p>
                  They frequently purchase from the most reputable merchant.
                  Therefore, in this instance, the website and marketing
                  materials must provide the customer with a sense of assurance
                  and security. Because of this, the website’s layout and
                  content are most important. Customers are more likely to
                  choose reliable sources while making purchases. Web and
                  software development must prioritize trust, security, and
                  brand loyalty in the B2C market as a result.
                </p>
                <p>
                  Our team of developers helps your company to reach its general
                  goal while working parallel to your business model by creating
                  software and apps whit adaptive UI design and development
                  while focusing on your promotions channel and sales process
                  which will reduce the general cost of development.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1">
              <div className="info-img">
                <img alt="infoImage" src={b2c} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Fourth;
